module.exports = __webpack_public_path__ + "media/images/home/icon-realestate-68cb8cca82186fac16db1c49366c7f84.png";